<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <DailyFirstDepositAnalysisTable/>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import DailyFirstDepositAnalysisTable from './DailyFirstDepositAnalysisTable'

  export default {
    name: 'daily-first-deposit-analysis-table',
    components: { DailyFirstDepositAnalysisTable }
  }
</script>



// WEBPACK FOOTER //
// src/views/report/risk/DailyFirstDepositAnalysis.vue